import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { ChartRelationshipIcon } from '@terra/ui-icons';

type IconCodeProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconCode({ appearance, density }: IconCodeProps) {
  return (
    <EntityIconBase
      icon={ChartRelationshipIcon}
      bg="bg.entity.pr"
      color="fg.entity.pr"
      borderColor="border.entity.pr"
      appearance={appearance}
      density={density}
    />
  );
}
